// import * as React from "react";
// import { V7_ROPERTIES_LENDERLIST } from '../../consts/queries';
// import { executeQuery } from "../../requests/executeQuery";
// import ListTable from '../ListTable';
// import { useEffect } from "react";
// const LenderProperty = (props) => {
//     const [data, setData] = React.useState([]);
//     const [loading, setLoading] = React.useState(false);
//     const fetch = () => {

//         const options = {
//             "param": {
//                 "limit": 1000,
//                 "offset": 0,
//                 "LENDER_ID":props.data.ARCIMEDES_ROW_ID
//             },
//             "filter": {
//                 "where": []
//             },

//         }
//         setLoading(true);
//         Promise.all([
//             executeQuery({ queryName: V7_ROPERTIES_LENDERLIST, options, expireTime: 1000 }),          
//         ]).then(values => {         
//             let result = values[0].data.map((e) => {
//                 e.SELECTED = false;
//                 return e;
//             });
//             setData(result);
//             setLoading(false);
//         });
//     }

//     useEffect(() => {
//         if (props.propertiesData && props.propertiesData.length == 0) {
            
//             fetch();
//         }
//         else if(props.propertiesData && props.propertiesData.length>0){
//             let result = props.propertiesData.filter((e) => e.LENDER_NAME === props.data.NAME)
//             result = result.map((e) => {
//                 e.SELECTED = false;
//                 return e;
//             });
//             setData(result);
//         }
//     }, [])

//     return (
//         <div className="LenderProperty-info">
//             {data.length == 0 && loading == false && <p>No Records Found</p>}
//             {data.length == 0 && loading == true && <p>Loading...please wait </p>}
//             <ListTable location={{
//                 query: {}
//             }}
//                 listings={data}
//                 isSuper={true}
//                 isAgent={false}
//                 isLender={true}
//                 isSeniorAgent={false}

//             />


//         </div>
//     );
// };

// export default LenderProperty;



import * as React from "react";
import { useQuery } from "@apollo/client";
import { GET_LENDER_PROPERTIES } from "../Graphql/Queries/LendersQuery";
import ListTable from '../ListTable';
import { useEffect } from "react";

const LenderProperty = (props) => {
    const [data, setData] = React.useState([]);
    const options = {
        pageSize: 50,
        page: 1
    };
    // Check if the ID exists in the URL or props
    const shouldFetch = Boolean(props.data.arcimedes_row_id);
    const { loading: queryLoading, data: queryData, error } = useQuery(GET_LENDER_PROPERTIES, {
        variables: { lenderId: props.data.arcimedes_row_id, pageOptions: options },
        skip: !shouldFetch, // Skip the query if no ID is present
    });

    const transformData = (rawData) => {
        return rawData.map((item) => ({
            ARCIMEDES_ROW_ID: item.arcimedes_row_id || null,
            SOURCE: item.source || null,
            status: item.status || null,
            HSC_STATUS: item.hsc_status || null,
            name: item.name || null,
            address: item.address || null,
            city: item.city || null,
            state: item.state || null,
            LATITUDE: item.latitude || null,
            LONGITUDE: item.longitude || null,
            type: item.type || null,
            category: item.category || null,
            sqft: item.sqft || null,
            list_price: item.list_price || null,
            LEASE_TYPE: item.lease_type || null,
            net_operating_income: item.net_operating_income || null,
            capitalization_rate: item.capitalization_rate || null,
            SOLD_PRICE: item.sold_price || null,
            CLOSE_OF_ESCROW: item.close_of_escrow || null,
            LISTED_DATE: item.listed_date || null,
            CLOSE_CAP_RATE: item.close_cap_rate || null,
            CLOSE_NOI: item.close_noi || null,
            PROFORMA_CAP_RATE: item.proforma_cap_rate || null,
            PROFORMA_NOI: item.proforma_noi || null,
            IS_PROFORMA_PRICING: item.is_proforma_pricing || null,
            CLOSE_PRICE_PER_SQFT: item.close_price_per_sqft || null,
            price_per_sqft: item.price_per_sqft || null,
            year_built: item.year_built || null,
            VISIBLE: item.visible || null,
            rent_per_sqft: item.rent_per_sqft || null,
            LEASE_EXPIRATION_DATE: item.lease_expiration_date || null,
            VACANCY: item.vacancy || null,
            MEDIA_KIT: item.media_kit || null,
            NEGOTIATION_PRICE: item.negotiation_price || null,
            NEGOTIATION_CAP_RATE: item.negotiation_cap_rate || null,
            LISTING_AGENT_1: item.listing_agent_1 || null,
            LISTING_AGENT_2: item.listing_agent_2 || null,
            LISTING_AGENT_3: item.listing_agent_3 || null,
            BUYER_AGENT_1: item.buyer_agent_1 || null,
            BUYER_AGENT_2: item.buyer_agent_2 || null,
            BUYER_AGENT_3: item.buyer_agent_3 || null,
            WEBSITE_PHOTO_1: item.website_photo_1 || null,
            negotiation_price_per_sqft: item.negotiation_price_per_sqft || null,
            DOWN_PAYMENT: item.down_payment || null,
            SELLER_FEE_PERCENTAGE: item.seller_fee_percentage || null,
            IS_LISTING: item.is_listing || null,
            WAS_PROPOSAL: item.was_proposal || null,
            EFFECTIVE_DATE: item.effective_date || null,
            HSC_FINANCING: item.hsc_financing || null,
            HSC_PRICE: item.hsc_price || null,
            LOAN_AMOUNT: item.loan_amount || null,
            LOAN_TYPE: item.loan_type || null,
            LTV: item.ltv || null,
            INTEREST_RATE: item.interest_rate || null,
            AMORTIZATION: item.amortization || null,
            TERM: item.term || null,
            AGENT_1_LAST_NAME: item.agent_1_last_name || null,
            AGENT_2_LAST_NAME: item.agent_2_last_name || null,
            AGENT_3_LAST_NAME: item.agent_3_last_name || null,
            AGENT_4_LAST_NAME: item.agent_4_last_name || null,
            SELLERS_FIRST_NAME: item.sellers_first_name || null,
            sellers_last_name: item.sellers_last_name || null,
            LENDER_NAME: item.lender_name || null,
            SELECTED: false // Adding the default "SELECTED" field
        }));
    };

    useEffect(() => {
        if (queryData) {
            const transformedData = transformData(queryData.v7PropertiesLenderList);
            setData(transformedData);
        } else if (props.propertiesData && props.propertiesData.length > 0) {
            const filteredData = props.propertiesData
                .filter((e) => e.LENDER_NAME === props.data.NAME)
                .map((e) => ({ ...e, SELECTED: false }));
            setData(filteredData);
        }
    }, [queryData, props.propertiesData]);

    return (
        <div className="LenderProperty-info">
            {data.length === 0 && queryLoading === false && <p>No Records Found</p>}
            {data.length === 0 && queryLoading === true && <p>Loading...please wait</p>}
            <ListTable
                location={{ query: {} }}
                listings={data}
                isSuper={true}
                isAgent={false}
                isLender={true}
                isSeniorAgent={false}
            />
        </div>
    );
};

export default LenderProperty;

